import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { renderFullCameraPane } from 'page/ProfileScreen/FullCameraPane/FullCameraPane'
import { store } from 'store/store'

export const FullStep = observer(() => {
  const onBack = useLatestCallback(() => {
    store.profile.step = 'profile'
  })

  const onDone = useLatestCallback(async () => {
    store.profile.step = 'profile'
  })

  return renderFullCameraPane(onBack, onDone)
})
